const state = {
    invoices: [],
    invoiceId:[],
    loading: false,
    documents: [],
    file: null,
    docLoader: false
};

export default state;